import { readCookie } from "@packages/util/cookie/cookie";

export default class ProviderUtils {
  static PROVIDER_KEY = "provider";

  static WifeedProviders = {
    WCS: "wcs",
    HAGGI: "haggi",
    TELY: "tely",
    NTCORP: "ntcorp",
    DATA_CARRIER: "data-carrier",
    VIVO: "vivo",
    VERO : 'vero',
    UNIFIQUE : 'unifique',
    ABC : 'abc',
    MASTER: 'master'
  };

  static ProviderUrls = {
    wifeed: 'https://system.wifeed.com.br',
    vivo: 'https://wifipro.vivowifi.net.br',
    vero: 'https://wifipro.querovero.com.br',
    unifique: 'https://wifib.unifique.com.br',
    abc: 'https://hotspotmaster.soumaster.com.br',
    master: 'https://masterhotspot.soumaster.com.br',
  };

  static getFromLocalStorage() {
    const provider = localStorage.getItem(this.PROVIDER_KEY);
    return provider ? provider.toLowerCase() : null;
  }

  static getFromCookie() {
    try {
      const raw = readCookie(this.PROVIDER_KEY);

      if (!raw) return null;

      let key = raw;

      try {
        const parsed = JSON.parse(raw);

        if (parsed && parsed.key) key = parsed.key;
      } catch (e) {
        key = raw;
      }

      const provider = String(key).toLowerCase();

      return this.isValid(provider) ? provider : null;
    } catch (e) {
      return null;
    }
  }

  static setInLocalStorage(provider) {
    localStorage.setItem(this.PROVIDER_KEY, provider);
  }

  static extractFromPathname(pathname) {
    const lastPart = pathname.split("/").filter(Boolean).pop();

    if (!lastPart) return null;

    const provider = lastPart.toLowerCase();

    return this.isValid(provider) ? provider : null;
  }

  static extractFromHostname(hostname) {
    const provider = Object.keys(this.ProviderUrls).find((key) =>
      this.ProviderUrls[key].includes(hostname)
    );

    return provider && this.isValid(provider) ? provider : null;
  }

  static extractFromUrl(url) {
    const { hostname, pathname } = new URL(url);

    return this.extractFromPathname(pathname) || this.extractFromHostname(hostname);
  }

  static isValid(provider) {
    return Object.values(this.WifeedProviders).includes(provider);
  }
}
